import React from "react";
import MobileMenuToggleButton from "./MobileMenuToggleButton";
import MobileNavBarBrand from "./MobileNavBarBrand";
import MobileNavBarButtons from "./MobileNavBarButtons";
import MobileNavBarTabs from "./MobileNavBarTabs";
import SeasonalLights from "../../seasonal/SeasonalLights";

const MobileMenuState = {
    CLOSED: "closed",
    OPEN: "open",
};

const MobileMenuIcon = {
    CLOSE: "close",
    MENU: "menu",
};

const MobileNavigationBar = () => {
    const [mobileMenuState, setMobileMenuState] = React.useState(
        MobileMenuState.CLOSED
    );
    const [mobileMenuIcon, setMobileMenuIcon] = React.useState(
        MobileMenuIcon.MENU
    );

    const isMobileMenuOpen = () => {
        return mobileMenuState === MobileMenuState.OPEN;
    };

    const closeMobileMenu = () => {
        document.body.classList.remove("mobile-scroll-lock");
        setMobileMenuState(MobileMenuState.CLOSED);
        setMobileMenuIcon(MobileMenuIcon.MENU);
    };

    const openMobileMenu = () => {
        document.body.classList.add("mobile-scroll-lock");
        setMobileMenuState(MobileMenuState.OPEN);
        setMobileMenuIcon(MobileMenuIcon.CLOSE);
    };

    const toggleMobileMenu = () => {
        if (isMobileMenuOpen()) {
            closeMobileMenu();
        } else {
            openMobileMenu();
        }
    };

    const menuOpen = isMobileMenuOpen();

    return (
        <>
            <div className="mobile-nav-bar__container">
                <nav className="mobile-nav-bar">
                    <MobileNavBarBrand onClickFunction={closeMobileMenu} />
                    <MobileMenuToggleButton
                        icon={mobileMenuIcon}
                        onClickFunction={toggleMobileMenu}
                    />
                </nav>
                <SeasonalLights />
            </div>
            {menuOpen && (
                <div className="mobile-nav-bar__menu">
                    <MobileNavBarTabs onClickFunction={closeMobileMenu} />
                    <MobileNavBarButtons />
                </div>
            )}
        </>
    );
};

export default MobileNavigationBar;